const ACCESS_KEY = "hiq_access_token"
const REFRESH_KEY = "hiq_refresh_token"

// Decode a JWT's payload (base64url → JSON). Returns null for anything
// that isn't a well-formed JWT — callers then treat expiry as UNKNOWN and
// fall back to the reactive 401 path rather than guessing.
function decodeJwtPayload(token) {
  try {
    const part = String(token).split(".")[1]
    if (!part) return null
    const b64 = part.replace(/-/g, "+").replace(/_/g, "/")
    const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4)
    return JSON.parse(atob(padded))
  } catch {
    return null
  }
}

const tokenService = {
  getAccessToken: () => localStorage.getItem(ACCESS_KEY),
  getRefreshToken: () => localStorage.getItem(REFRESH_KEY),

  /**
   * Whether the stored access token is expired (or within ``skewMs`` of it).
   * CONSERVATIVE: true ONLY when the JWT's ``exp`` decodes to a past time —
   * a missing token, a non-JWT, or a token without ``exp`` all return false
   * so the proactive-refresh guard leaves them to the reactive 401 handler.
   *
   * @param {number} [skewMs=10000] treat "expires within this window" as expired
   * @returns {boolean}
   */
  isAccessTokenExpired: (skewMs = 10000) => {
    const token = localStorage.getItem(ACCESS_KEY)
    if (!token) return false
    const payload = decodeJwtPayload(token)
    if (!payload || typeof payload.exp !== "number") return false
    return Date.now() >= payload.exp * 1000 - skewMs
  },

  setTokens: ({ access_token, refresh_token }) => {
    if (access_token) localStorage.setItem(ACCESS_KEY, access_token)
    if (refresh_token) localStorage.setItem(REFRESH_KEY, refresh_token)
  },

  clear: () => {
    localStorage.removeItem(ACCESS_KEY)
    localStorage.removeItem(REFRESH_KEY)
  },
}

export default tokenService
